import React from 'react';

function ParticipantName(props) {
  return <span>{props.participant.name}</span>;
}

export default ParticipantName;



// WEBPACK FOOTER //
// ./src/components/ParticipantName.js